module.exports = __webpack_public_path__ + "media/customizations/cannerydistrict/logo-4d19dcafe0f83fc28347f9c674930c1f.png";